import React, { useState, useContext } from 'react';


import InputSettingsField from './InputSettingsField';
import ButtonGroupSettings from './ButtonGroupSettings';
import { StyledFieldWrapper, DividerLine, StyledErrorMessage } from './SettingsCommonElements';

import ThemeIcons from '../../../theme/Icons';
import ThemeContext from '../../../theme/ThemeContext';
import { validateDateTimeFormat } from '../../../lib/dateTimeHelper';

const DateFormatSettings = ({ format, onChange, customDateTimeFormatEnabled }) => {

  const [formatError, setFormatError] = useState('');
  const theme = useContext(ThemeContext);

  return (
    <>
      {customDateTimeFormatEnabled && (
        <StyledFieldWrapper>
          <InputSettingsField
            label="Format"
            description="Options: DD (day), MM (month), YYYY (year), hh (12 hour), HH (24 hour), mm (minute), a (am/pm), - (dash), / (slash), : (colon), space (space)"
            fieldId="date-format-input"
            value={format}
            type="text"
            onChange={(e, value) => {
              if (validateDateTimeFormat(value)) {
                onChange(value);
                setFormatError('');
              } else {
                setFormatError('Invalid format. Please use the supported format options above.');
              }
            }}
          />
          {formatError && (
            <StyledErrorMessage theme={theme}>
              Invalid format. Please use the supported format options above.
            </StyledErrorMessage>
          )}
        </StyledFieldWrapper>
      )}
      <StyledFieldWrapper style={{ marginBottom: 0 }}>
        <ButtonGroupSettings
          id="date-format-buttons"
          types={[
            {
              type: 'MM/DD/YYYY',
              icon: ThemeIcons.settings.formatDate,
              active: format === 'MM/DD/YYYY',
            },
            {
              type: 'MM/DD/YYYY hh:mma',
              icon: ThemeIcons.settings.formatDateTime,
              active: format === 'MM/DD/YYYY hh:mma',
            },
            {
              type: 'hh:mma',
              icon: ThemeIcons.settings.formatTime,
              active: format === 'hh:mma',
            }
          ]}
          onChange={onChange}
        />
      </StyledFieldWrapper>
    </>
  );

};

export default DateFormatSettings;
